
import { Component } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase'
import Util from '@/lib/util';
import header1 from '@/components/headers/header.vue'
import footer1 from '@/components/footers/footer.vue'
import Membership from '../store/entities/auth/Membership';
import AppConsts from '@/lib/appConst';
import Wallet from '@/store/entities/finance/Wallet';

@Component({
  components: { header1, footer1 }
})
export default class PersonalCenterHome extends AbpBase {
  wallet: Wallet = new Wallet();
  qrCodeUrl: string = '/img/work-wx-cs.png'
  showQrCode: boolean = false

  get tenant() {
    return Util.abp.multiTenancy.getTenantCookie();
  }

  get isStandardEdition() {
    return Util.isStandardEdition();
  }

  get user() {
    if (this.$store.state.session.user) {
      return this.$store.state.session.user;
    } else {
      return {};
    }
  }

  get userProfile() {
    if (this.$store.state.session.userProfile) {
      return this.$store.state.session.userProfile;
    } else {
      return {};
    }
  }

  get membership() {
    if (this.$store.state.session.membership) {
      return this.$store.state.session.membership;
    } else {
      return new Membership();
    }
  }

  get vendor() {
    return Util.abp.multiTenancy.getVendorCookie();
  }

  get avatar() {
    let avatar = this.userProfile.avatarImageUrl;
    if (!avatar) {
      return AppConsts.user.avatar;
    }
    return avatar;
  }

  created() {
    // 页面跳转
    const returnUrl = localStorage.getItem('LoginReturnUrl');
    if (returnUrl && returnUrl !== '/pc/home') {
      localStorage.setItem('LoginReturnUrl', '')
      location.href = returnUrl
    }
  }

  mounted() {
    this.$store.commit('app/showSidebarMenu');

    setTimeout(() => {
      this.getWallet();
    }, 1000);

    this.isSubscribed();
  }

  getWallet() {
    this.$store.dispatch({
      type: 'wallet/getByUser',
      data: {
        userNo: Util.abp.session.getUserNoCookie()
      },
    }).then(data => {
      this.wallet = data;
    });
  }

  isSubscribed() {
    this.$store.dispatch({
      type: 'weixin/isSubscribed'
    }).then(resp => {
      if (!resp.subscribed) {
        this.getQrCode();
      }
    })
  }

  getQrCode() {
    this.$store.dispatch({
      type: 'weixin/getSubscribeQrCode'
    }).then(resp => {
      this.qrCodeUrl = resp
      this.showQrCode = true
    })
  }

  onDownloadQrCode(fileUrl) {
    Util.downloadFile(fileUrl);
  }
}
